const FETCH_AV_ALTERNATIVES_REQUEST = 'FETCH_AV_ALTERNATIVES_REQUEST'
const FETCH_AV_ALTERNATIVES_SUCCESS = 'FETCH_AV_ALTERNATIVES_SUCCESS'
const FETCH_AV_ALTERNATIVES_FAILURE = 'FETCH_AV_ALTERNATIVES_FAILURE'
const UPDATE_AV_ALTERNATIVES = 'UPDATE_AV_ALTERNATIVES'
export {
  FETCH_AV_ALTERNATIVES_REQUEST,
  FETCH_AV_ALTERNATIVES_SUCCESS,
  FETCH_AV_ALTERNATIVES_FAILURE,
  UPDATE_AV_ALTERNATIVES
}
